import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Each site loads its own GA4 property in public/index.html (GA4_BY_SITE) and exposes it as
// window.__GA4_ID__. These helpers only send events through that site's tag; there is no network-wide ID.
const siteTagReady = () => typeof window !== 'undefined' && !!window.__GA4_ID__ && typeof window.gtag === 'function';

// Kept for existing callers (AutoHome/CouponHome). The tag itself is loaded by index.html.
export const initGA = () => {};

// Page views are sent by the site tag itself: gtag('config') records the landing page and GA4 Enhanced
// Measurement ("page changes based on browser history events", on by default) records SPA navigations.
// Sending them here as well would double-count, so this stays a no-op for existing callers.
export const trackPageView = () => {};

export const trackEvent = (action, category, label, value, site) => {
  if (!siteTagReady()) return;
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
    custom_site: site,
  });
};

// React hook for automatic page tracking
export const usePageTracking = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
};

// Store UTM params in sessionStorage for attribution
export const storeUTMParams = () => {
  const params = new URLSearchParams(window.location.search);
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'aff'];
  utmKeys.forEach(key => {
    const val = params.get(key);
    if (val) sessionStorage.setItem(key, val);
  });
};

export const getStoredUTMParams = () => {
  return {
    utm_source: sessionStorage.getItem('utm_source') || '',
    utm_medium: sessionStorage.getItem('utm_medium') || '',
    utm_campaign: sessionStorage.getItem('utm_campaign') || '',
    aff: sessionStorage.getItem('aff') || '',
  };
};

// Event helpers
export const trackLeadSubmission = (source, vehicleType) => {
  trackEvent('lead_submitted', 'conversion', `${source}_${vehicleType}`, 1);
};

export const trackCouponClaim = (couponId, brand) => {
  trackEvent('coupon_claimed', 'engagement', brand, 1);
};

export const trackSearch = (query, site) => {
  trackEvent('search', 'engagement', query, 0, site);
};

export const trackAdClick = (adId, adType, placement) => {
  trackEvent('ad_click', 'advertising', `${adType}_${placement}`, 1);
};

export const trackAdImpression = (adId, adType, placement) => {
  trackEvent('ad_impression', 'advertising', `${adType}_${placement}`, 1);
};

export const trackPriceReveal = (vehicleId, vehicleType) => {
  trackEvent('price_revealed', 'conversion', vehicleType, 1);
};
